$('.herbarFeed').slick({
 slidesToShow: 6,
 slidesToScroll: 1,
 centerMode: false,
 autoplay: false,
 autoplaySpeed: 5000,
 dots: true,
 arrows: false,
 infinite: false,
 adaptiveHeight: false,
 responsive: [
  {
    breakpoint: 1439,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 1,
     
    }
  },
  {
     breakpoint: 1199,
     settings: {
       slidesToShow: 5,
       slidesToScroll: 1,
      
     }
   },
   {
     breakpoint: 991,
     settings: {
      slidesToShow: 4,
      slidesToScroll: 1,
      
    }
    
   },
   {
     breakpoint: 768,
     settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
    }
    
   },
   {
     breakpoint: 480,
     settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      
    }
    
   }
 ]
});